import { c as _c } from "react/compiler-runtime";
import { CapabilityNode } from "@/data/CapabilityData";
import CapabilityAutopilotRow from "./CapabilityAutopilotRow";
import CapabilitySpeedChart from "./CapabilitySpeedChart";
import CapabilityCmsEditor from "./CapabilityCmsEditor";
import CapabilitySeoSearch from "./CapabilitySeoSearch";
import CapabilityDeviceRail from "./CapabilityDeviceRail";
import CapabilityUptimeFeed from "./CapabilityUptimeFeed";
const CapabilityCardVisual = t0 => {
  const $ = _c(9);
  const {
    node
  } = t0;
  switch (node.kind) {
    case "stack":
      {
        let t1;
        if ($[0] !== node.chips) {
          t1 = node.chips ?? [];
          $[0] = node.chips;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        let t2;
        if ($[2] !== t1) {
          t2 = <CapabilityAutopilotRow tasks={t1} />;
          $[2] = t1;
          $[3] = t2;
        } else {
          t2 = $[3];
        }
        return t2;
      }
    case "speed":
      {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <CapabilitySpeedChart />;
          $[4] = t1;
        } else {
          t1 = $[4];
        }
        return t1;
      }
    case "cms":
      {
        let t1;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <CapabilityCmsEditor />;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "seo":
      {
        let t1;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <CapabilitySeoSearch />;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        return t1;
      }
    case "responsive":
      {
        let t1;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <CapabilityDeviceRail />;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    case "uptime":
      {
        let t1;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <CapabilityUptimeFeed />;
          $[8] = t1;
        } else {
          t1 = $[8];
        }
        return t1;
      }
  }
};
export default CapabilityCardVisual;